import { Action, createReducer, on } from '@ngrx/store';
import { adminLocationActions } from './admin-location.action';
import { AdminLocationState, adminLocationIS } from './admin-location.state';

const adminLocationRegister = createReducer(
  adminLocationIS,
  on(adminLocationActions.setQuerySerch, (state, { items }) => ({
    ...state,
    queryResult: [...items],
  })),

  on(adminLocationActions.setResultAction, (state, { result }) => ({
    ...state,
    result,
  })),

  on(adminLocationActions.putLocationAction, (state, location) => ({
    ...state,
    result: [...state.result, location],
  })),

  on(adminLocationActions.patchLocationAction, (state, location) => ({
    ...state,
    result: state.result.map((item) => {
      if (item.id === location.id) {
        return location;
      }
      return item;
    }),
  })),

  on(adminLocationActions.setLocationAction, (state, modal) => ({
    ...state,
    modal,
  })),

  on(adminLocationActions.setLocationDefaultAction, (state) => ({
    ...state,
    modal: adminLocationIS.modal,
  })),

  on(adminLocationActions.setAllDefaultAction, () => adminLocationIS)
);

export function adminLocationReducer(
  state: AdminLocationState,
  action: Action
): any {
  return adminLocationRegister(state, action);
}
